export const ERRORS = {
  createIssueError: 'Unable to create issue.',
}
